(function () {
  //処理
  const generateItemChart = () => {
    let table_wrapper = document.querySelector('.table_wrapper');
    let table = document.querySelector('.table');

    const imgClick = (target) => {
      location.href = target.dataset.url;
    }

    let option = {
      items: chartItems,
      x: {
        min: 0,
        max: 6,
      },
      y: {
        min: 0,
        max: 6,
      },
      mentholPath: mentholPath,
      imgClick: imgClick,
    }

    let productData = new ItemsChart(table, table_wrapper, option);
    WAU.Helpers.lazyLoad('.lazy', true);
    return productData
  }

  // ウインドウの横幅を保持
  var currentWidth = window.innerWidth;

  let itemChart = generateItemChart();
  window.addEventListener("resize", function() {
    if (currentWidth == window.innerWidth) {
      // ウインドウ横幅が変わっていないため処理をキャンセル。
      return;
    }

    // ウインドウ横幅が変わったのでリサイズと見なす。
    // 横幅を更新
    currentWidth = window.innerWidth;

    // 再レンダリング
    itemChart.update();
    WAU.Helpers.lazyLoad('.lazy', true);
  });

  // document.addEventListener('shopify:section:load', (event) => {
  //   console.log(chartItems)
  //   if(itemChart) {
  //     itemChart.delete();
  //   }

  //   itemChart = generateItemChart()
  //   WAU.Helpers.lazyLoad('.lazy', true);
  // })
}());
